const EducationData = [
  {
    school: "University of Michigan – Ann Arbor",
    logoKey: "umich",
    period: "Aug 2021 – Apr 2023",
    degree: "Master of Science in Robotics",
    gpa: "3.96 / 4.0",
    coursework: [
      "Self-Driving Cars",
      "Computer Vision",
      "Machine Learning",
      "Robotics Lab",
      "Math for Robotics",
      "Programming for Robotics",
    ],
  },
  {
    school: "Manipal Institute of Technology, Manipal",
    logoKey: "manipal",
    period: "Jul 2016 – Jul 2020",
    degree: "Bachelor of Technology in Mechatronics",
    gpa: "9.29 / 10.0",
    coursework: [
      "Artificial Intelligence",
      "Computer Vision & Image Processing",
      "Machine Learning",
      "Path Planning",
      "Robot Kinematics and Dynamics",
    ],
  },
];

export default EducationData;